/* Kick Frame — upsell in de winkelwagen-lade (staat ONDER de producten in het schuifbare deel, zodat poster en afrekenknop zichtbaar blijven).
   Ligt er precies één A3-poster zonder lijst in de wagen, dan bieden we een tweede A3 aan
   (automatische korting "2 A3 posters voor €44,99"). Ligt er precies één poster in die geen A3 is,
   dan bieden we een tweede A4 zonder lijst aan (automatische korting "Tweede A4-poster voor €14,99").
   Bij een toegepaste korting tonen we een bevestiging. De lade zelf komt uit kickframe.js. */
(function () {
  var EXCLUDE = /^(eigen-ontwerp|kids-football-poster|gift-card)$/;
  var NL = /^\/nl(\/|$)/.test(location.pathname);
  var A4_PRICE = 1499;
  function unframed(t) { return /paper poster$/.test(t) || /\/ geen$/.test(t); }
  function isDealVariant(item) {
    var t = (item.variant_title || '').toLowerCase();
    return t.indexOf('a3') === 0 && unframed(t);
  }
  function isA4Variant(item) {
    var t = (item.variant_title || '').toLowerCase();
    return t.indexOf('a4') === 0 && unframed(t);
  }
  function kfName(t) { return String(t || '').replace(/ (Football Poster|Stadium Poster|Voetbalposter|Stadionposter)$/, ''); }
  function money(c) { var s = '€' + (c / 100).toFixed(2); return NL ? s.replace('.', ',') : s; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) { if (!src) return ''; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  function hasDiscount(cart, re) {
    return cart.items.some(function (i) {
      return (i.line_level_discount_allocations || []).some(function (d) { return re.test((d.discount_application || {}).title || ''); });
    });
  }

  var style = document.createElement('style');
  style.textContent = ''
    + '.kf-upsell{margin:.5rem 0 0;padding:1rem;border:1px solid var(--gold,#d6b25e);border-radius:12px;background:rgba(214,178,94,.07)}'
    + '.kf-upsell h3{margin:0 0 .2rem;font-size:1rem;color:var(--ink,#fff)}'
    + '.kf-upsell p{margin:0 0 .8rem;font-size:.85rem;opacity:.8}'
    + '.kf-upsell-item{display:flex;align-items:center;gap:.75rem;padding:.45rem 0;border-top:1px solid rgba(255,255,255,.08)}'
    + '.kf-upsell-item img{width:48px;height:64px;object-fit:cover;border-radius:4px;flex:none}'
    + '.kf-upsell-item span{flex:1;font-size:.88rem;line-height:1.3}'
    + '.kf-upsell-item button{flex:none;padding:.5rem .75rem;border-radius:999px;border:0;background:var(--green,#2f8f5b);color:#fff;font:600 .8rem/1 inherit;cursor:pointer}'
    + '.kf-upsell-item button[disabled]{opacity:.6;cursor:wait}'
    + '.kf-upsell--ok{border-color:var(--green,#2f8f5b);background:rgba(47,143,91,.1)}';
  document.head.appendChild(style);

  function offer(drawer, footer, cart, base, pick, title, text, priceLabel) {
    var inCart = cart.items.map(function (i) { return i.product_id; });
    return fetch('/recommendations/products.json?product_id=' + base + '&limit=10&intent=related')
      .then(function (r) { return r.json(); }).then(function (data) {
        var picks = (data.products || []).filter(function (p) {
          return inCart.indexOf(p.id) < 0 && !EXCLUDE.test(p.handle);
        }).map(function (p) {
          var v = (p.variants || []).filter(function (v) { return v.available && pick({ variant_title: v.title }); })[0];
          return v ? { p: p, v: v } : null;
        }).filter(Boolean).filter(function (x, i, all) {
          // twee producten met dezelfde naam (bijv. twee Messi-posters) maar één keer tonen
          return all.findIndex(function (y) { return kfName(y.p.title) === kfName(x.p.title); }) === i;
        }).slice(0, 3);
        if (!picks.length || drawer.querySelector('.kf-upsell')) return;
        var box = document.createElement('div'); box.className = 'kf-upsell';
        box.innerHTML = '<h3>' + title + '</h3><p>' + text + '</p>'
          + picks.map(function (x) {
            return '<div class="kf-upsell-item"><img src="' + esc(img(x.p.featured_image, 120)) + '" alt="" loading="lazy">'
              + '<span>' + esc(kfName(x.p.title)) + '<br><small style="opacity:.7">' + priceLabel(x.v) + '</small></span>'
              + '<button type="button" data-kf-add="' + x.v.id + '">' + (NL ? '+ Toevoegen' : '+ Add') + '</button></div>';
          }).join('');
        (drawer.querySelector('[data-cart-drawer-lines]') || footer.parentNode).appendChild(box);
      });
  }

  var busy = false, lastKey = '';
  function render(drawer) {
    if (busy) return; busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      // kinderposter en eigen ontwerp in A3 tellen wél mee voor de korting; ze worden alleen niet voorgesteld
      var deal = cart.items.filter(function (i) { return isDealVariant(i) && i.handle !== 'gift-card'; });
      var count = deal.reduce(function (s, i) { return s + i.quantity; }, 0);
      var posters = cart.items.filter(function (i) { return i.handle !== 'gift-card'; });
      var total = posters.reduce(function (s, i) { return s + i.quantity; }, 0);
      var key = count + ':' + total + ':' + cart.total_discount + ':' + cart.items.map(function (i) { return i.key; }).join(',');
      var box = drawer.querySelector('.kf-upsell');
      if (key === lastKey && box) return;
      lastKey = key;
      if (box) box.remove();
      var footer = drawer.querySelector('[data-cart-drawer-footer]');
      if (!footer || !cart.items.length) return;
      if (cart.total_discount > 0 && (hasDiscount(cart, /A4/) || (count >= 2 && hasDiscount(cart, /A3/)))) {
        var a4 = hasDiscount(cart, /A4/);
        box = document.createElement('div'); box.className = 'kf-upsell kf-upsell--ok';
        box.innerHTML = '<h3>✓ ' + (a4 ? (NL ? '2e A4-poster voor €14,99' : '2nd A4 poster for €14.99') : (NL ? '2 A3-posters voor €44,99' : '2 A3 posters for €44.99')) + '</h3>'
          + '<p style="margin:0">' + (NL ? 'Korting toegepast: je bespaart ' : 'Deal applied: you save ') + money(cart.total_discount) + '.</p>';
        (drawer.querySelector('[data-cart-drawer-lines]') || footer.parentNode).appendChild(box); return;
      }
      if (count === 1 && total === 1) {
        return offer(drawer, footer, cart, deal[0].product_id, isDealVariant,
          NL ? 'Voeg een tweede A3 toe – samen €44,99' : 'Add a second A3 – pay €44.99 for both',
          NL ? 'Combineer elk ontwerp. De korting gaat automatisch.' : 'Mix any designs. The discount is applied automatically.',
          function (v) { return 'A3 · ' + money(v.price); });
      }
      if (total === 1 && !EXCLUDE.test(posters[0].handle)) {
        return offer(drawer, footer, cart, posters[0].product_id, isA4Variant,
          NL ? 'Tweede poster? A4 voor maar €14,99' : 'Add a second poster – A4 for just €14.99',
          NL ? 'Kies er nog één bij. De korting gaat automatisch.' : 'Pick one more. The discount is applied automatically.',
          function (v) { return 'A4 · <s style="opacity:.6">' + money(v.price) + '</s> ' + money(A4_PRICE); });
      }
    }).catch(function () {}).then(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kf-add]');
    if (!btn) return;
    btn.disabled = true; btn.textContent = NL ? 'Toevoegen…' : 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-kf-add')), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; lastKey = ''; var link = document.querySelector('[data-cart-toggle]'); if (link) link.click(); })
      .catch(function () { btn.disabled = false; btn.textContent = NL ? '+ Toevoegen' : '+ Add'; });
  });

  // de lade wordt door kickframe.js gemaakt en bij elke wijziging opnieuw gevuld
  new MutationObserver(function () {
    var drawer = document.querySelector('.cart-drawer');
    if (drawer && !drawer.dataset.kfUpsell) {
      drawer.dataset.kfUpsell = '1';
      var footer = drawer.querySelector('[data-cart-drawer-footer]');
      new MutationObserver(function () { render(drawer); }).observe(footer, { childList: true });
      render(drawer);
    }
  }).observe(document.body, { childList: true });
})();
